// // Axios is a great http client library.
// // It uses promises by default and runs on both the client and the server (which makes it appropriate for fetching data during server-side rendering).
import axios from 'axios'
// import vueCookie from 'vue-cookie'
// import store from '@/store'
// import router from '@/router'
import Vue from 'vue'
import alertify from 'alertifyjs'
Vue.use(alertify)

// console.log(window)
// window.lang = window.location.search.split('=')[1]
// console.log('lang', window.lang)
const HTTP = axios.create({
  baseURL: JSON.parse(window.localStorage.ApiculusEnv).api.url + '/api/v1/',
  // baseURL: process.env.API_PORT ? process.env.API_URL + ':' + process.env.API_PORT + '/api/v1/' : process.env.API_URL + '/api/v1',
  // baseURL: 'https://mycloudapi.nxtradata.com/api/v1/',
  // baseURL: 'http://cloudapi.apiculus.iqtest:33333/api/v1/',
  headers: {
    'Access-Control-Allow-Origin': true,
    // 'x-access-token': vueCookie.get('access-token'),
    'x-no-cache': 1
  }
})

HTTP.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  },
  error => {
    // if (error.response.data.httpStatus === 401 || error.response.data.httpStatus === 403) {
    //   // alert('Session terminated due to invalid access token')
    //   alertify.set('notifier', 'position', 'top-center')
    //   alertify.error('Session terminated due to invalid access token')
    //   vueCookie.delete('access-token')
    //   store.commit('MUTATION_AUTH_ERROR')
    //   router.push('/')
    // } else {
    //   // alert('An error occured')
    // }
    // alertify.set('notifier', 'position', 'top-center')
    // alertify.error('An error occured', error)
    return Promise.reject(error)
  }
)
export default HTTP
